import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import DefaultAccountants from './DefaultAccountants';

const AccountantsPicker = (props) => {
  const { householdResource } = useSimpleHousehold();

  return pickFunction(householdResource, {
    [fr.relationships.default.name]: () => {
      return (
        <DefaultAccountants {...props} />
      );
    },
  });
};

export default AccountantsPicker;
